import { render, staticRenderFns } from "./Carrusel.vue?vue&type=template&id=7c8dab10&scoped=true&"
import script from "./Carrusel.vue?vue&type=script&lang=js&"
export * from "./Carrusel.vue?vue&type=script&lang=js&"
import style0 from "./Carrusel.vue?vue&type=style&index=0&id=7c8dab10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8dab10",
  null
  
)

export default component.exports